module.exports = __webpack_public_path__ + "media/img/help_center/Student_Institution_Directory_03-a5dc3b8dcafaf85f05e12e6880c5e307.jpg";